import { Calculation, DateRange } from "../model";

/**
 * Abstracts the data from Calculation that a row usecase may use in update method.
 * Separated so that it is clear which parts of a calculation may be used by row usecases.
 */
export class RowUsecaseCalcData {

  /**
   * Creates the RowUsecaseCalcData from a calculation.
   * @param calc Calculation that is used in the usecase.
   */
  public static fromCalc(calc: Calculation): RowUsecaseCalcData {
    const result = new RowUsecaseCalcData();
    if (calc?.info) {
      result.hasValues = true;
      result.period = {
        start: calc.info.workStartDate,
        end: calc.info.workEndDate,
        daysCount: calc.framework.numberOfDays,
      };
      if (calc.result?.totals) {
        result.foreclosureSalary = calc.result.workerCalc.salaryAfterTax - calc.result.workerCalc.pension - calc.result.workerCalc.unemploymentInsurance;
        result.totalTaxable = calc.result.totals.totalTaxable;
      }
      result.employerOfficialId = calc.employer?.officialId;
      result.workerOfficialId = calc.worker?.paymentData?.socialSecurityNumberValid;
    }
    return result;
  }

  /** If true, the values have been set - there was the calculation */
  public hasValues = false;

  /** Period for the calculation with days count. */
  public period: DateRange = {};

  /** Salary for foreclosure is salaryAfterTax minus pension and unemploymentInsurance. */
  public foreclosureSalary?: number;

  /** Total taxable income. */
  public totalTaxable?: number;

  /** Employer official id */
  public employerOfficialId?: string;

  /** Worker official id */
  public workerOfficialId?: string;
}